<template>
    <form-row title="Taxes"
        label_class="md:pb-22"
    >
        <input-money
            :value="mortgage.taxes"
            name="taxes"
            :read_only="read_only"
        />

        <div class="flex flex-col mt-4 sm:-mt-1 sm:ml-10 flex-1">
            <input-radio-boolean
                class="mb-6 mt-3"
                name="taxes_are_monthly"
                :value="mortgage.taxes_are_monthly"
                true="Monthly"
                false="Yearly"
                :read_only="read_only"
            />

            <input-radio-boolean
                label="Is your bank escrowing and paying your taxes?"
                name="is_bank_escrowing_taxes"
                :value="mortgage.is_bank_escrowing_taxes"
                true="Yes"
                false="No"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        mortgage: {},
        read_only: { default: false },
    },
}
</script>
